var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3601 8.9398C17.9401 9.1198 17.4601 9.2398 16.9801 9.2998C17.4601 8.9998 17.8801 8.51981 18.0601 7.97981C17.5801 8.27981 17.1001 8.45981 16.5001 8.57981C16.0801 8.09981 15.4201 7.7998 14.7601 7.7998C13.4401 7.7998 12.3601 8.8798 12.3601 10.1998C12.3601 10.3798 12.3601 10.5598 12.4201 10.7398C10.4401 10.6198 8.64009 9.6598 7.44009 8.2198C7.26009 8.5798 7.14009 8.9998 7.14009 9.4198C7.14009 10.2598 7.5601 10.9798 8.2201 11.3998C7.8001 11.3998 7.44009 11.2798 7.14009 11.0998C7.14009 12.2398 7.98009 13.2598 9.06009 13.4398C8.88009 13.4998 8.6401 13.4998 8.4001 13.4998C8.2201 13.4998 8.1001 13.4998 7.9201 13.4398C8.2201 14.3998 9.1201 15.1198 10.2001 15.1198C9.3601 15.7798 8.3401 16.1398 7.2001 16.1398C7.0201 16.1398 6.8401 16.1398 6.6001 16.0798C7.6801 16.7398 8.9401 17.1598 10.3201 17.1598C14.7601 17.1598 17.1601 13.4998 17.1601 10.3198V10.0198C17.6401 9.8398 18.0601 9.4198 18.3601 8.9398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.e723577f1b0ca511bc2a466ae350769e.svg";
export { ForwardRef as ReactComponent };